module.exports = __webpack_public_path__ + "static/media/about-us.f7dcb8d8.png";